// extracted by mini-css-extract-plugin
export default {"container":"WhatFabit_container__Kmghs","heading":"WhatFabit_heading__wSzsy","iframe":"WhatFabit_iframe__V9gIY","rightContent":"WhatFabit_rightContent__8L9Pu"};